<template>
  <div class="table-content">
    <tr
      v-for="(listItem, index) in tableContentLists"
      :key="index"
      class="table-list"
    >
      <td
        v-for="columnItem in renderHeaderList"
        :key="columnItem.name"
        :class="[columnItem.cls || columnItem.name]"
        :title="columnItem.needHover ? showItem(listItem, columnItem) : '' "
      >
        <a
          v-if="interactionFunc[columnItem.name] && isColumnLinkEnabled(listItem, columnItem)"
          class="underline"
          @click="() => doInteractionFunc(columnItem.name, listItem)"
        >
          <template v-if="isColComponentItem(columnItem)">
            <component :is="showItem(listItem, columnItem)" />
          </template>
          <template v-else>
            {{ showItem(listItem, columnItem) }}
          </template>
        </a>
        <span
          v-else-if="shouldShowDisabledColumnLink(columnItem, listItem)"
          class="table-content__action--disabled"
        >
          <component
            :is="columnItem.component"
            :disabled="true"
          />
        </span>
        <span
          v-else-if="columnItem.pureText"
        >{{ showItem(listItem, columnItem) }}</span>
        <span
          v-else
          v-html="showItem(listItem, columnItem)"
        />
      </td>
    </tr>
  </div>
</template>

<script>
import dateUtil from '@/utils/dateUtil'
import { INPUT_TYPE } from '@/modules/contacts/searchFilter.const'
import { isComponent } from '@/utils/componentUtils'

export default {
  name: 'TableContent',
  props: {
    /**
     * [{
     * formatRule: function // formate data function
     * allowLink: boolean // allow execute the interaction function
     * allowLinkByColumn: { [columnName]: boolean } // per-column link override
     * pureText: boolean // output a pure text string.
     * }]
     * */
    tableContentLists: {
      type: Array,
      default: () => ([]),
    },
    renderHeaderList: {
      type: Array,
      required: true,
    },
    /**
     * [{name, func}] click name's td will call the function
     * */
    interactionFunc: {
      type: [Object, String],
      default: '',
    },
    // names of renderHeaderList will be format as date
    orderByDateKeys: {
      type: Array,
      default: () => ([]),
    },
  },
  methods: {
    showItem (listItem, colItem) {
      return (listItem[colItem.name] || typeof colItem.formatRule === 'function') ? this.formatItem(listItem, colItem) : colItem.defaultValue
    },
    isColComponentItem (colItem) {
      return INPUT_TYPE.COMPONENT === colItem.inputType && isComponent(colItem.component)
    },
    formatItem (listItem, colItem) {
      switch (true) {
        case typeof colItem.formatRule === 'function':
          return colItem.formatRule(listItem[colItem.name], listItem)
        case this.isColComponentItem(colItem):
          return colItem.component
        case INPUT_TYPE.DATE === colItem.inputType:
        case this.orderByDateKeys.includes(colItem.name):
          return dateUtil.formatDate(listItem[colItem.name], true)
        default:
          return listItem[colItem.name]
      }
    },
    doInteractionFunc (name, item) {
      const func = this.interactionFunc && this.interactionFunc[name]
      if (func) {
        func(item)
      }
    },
    isColumnLinkEnabled (listItem, columnItem) {
      const allowLinkByColumn = listItem.allowLinkByColumn
      if (allowLinkByColumn && Object.prototype.hasOwnProperty.call(allowLinkByColumn, columnItem.name)) {
        return allowLinkByColumn[columnItem.name]
      }
      return listItem.allowLink
    },
    shouldShowDisabledColumnLink (columnItem, listItem) {
      if (!this.interactionFunc || !this.interactionFunc[columnItem.name]) return false
      if (!this.isColComponentItem(columnItem)) return false
      if (!listItem[columnItem.name]) return false
      return !this.isColumnLinkEnabled(listItem, columnItem)
    },
  },
}
</script>

<style lang="scss" scoped>
.table-content {
  .underline {
    text-decoration: underline;
    cursor: pointer;
  }
  .table-content__action--disabled {
    display: inline-block;
  }
  td {
    word-break: break-word;
    word-wrap: break-word;
    vertical-align: middle;
    text-align: left;
    padding: 10px;
    font-size: 14px;
    min-height: 41px;
    display: inline-block;
  }
  tr {
    display: inline-block;
    border-bottom: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
  }
  tr:nth-child(odd) {
    background: #FBFBFB;
  }
  tr:nth-child(even) {
    background: white
  }
}
</style>
